import { render, staticRenderFns } from "./tarif-einstellungen.vue?vue&type=template&id=332ef2e0&"
import script from "./tarif-einstellungen.vue?vue&type=script&lang=js&"
export * from "./tarif-einstellungen.vue?vue&type=script&lang=js&"
import style0 from "./tarif-einstellungen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports